import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import { KDSUISettings } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/settings/kds/kds_ui_settings';
import { FulfillmentType } from '@square/dashboard-protos/models/squareup/omg/fulfillment/fulfillment';
export const FulfillmentTypeColorConfiguration = ProtoBaseModel.extend({
  fulfillmentType: attr(FulfillmentType),
  color: attr(KDSUISettings.ChitHeaderColor)
});
export const DiningOptionColorConfiguration = ProtoBaseModel.extend({
  diningOptionId: attr(String),
  color: attr(KDSUISettings.ChitHeaderColor)
});
export const TicketLayoutSetting = ProtoBaseModel.extend({
  headerType: attr(KDSUISettings.ChitHeaderType),
  fulfillmentTypeColorConfiguration: repeated(FulfillmentTypeColorConfiguration),
  diningOptionColorConfiguration: repeated(DiningOptionColorConfiguration),
  customizeDiningOptionsEnabled: attr(Boolean)
});
export const Layout = ProtoBaseModel.extend({
  layoutType: attr(KDSUISettings.Layout.LayoutType),
  selected: attr(Boolean)
});
export const Sound = ProtoBaseModel.extend({
  soundType: attr(KDSUISettings.Sound.SoundType),
  enabled: attr(Boolean)
});
export const TimerSetting = ProtoBaseModel.extend({
  timerType: attr(KDSUISettings.TimerSetting.TimerType),
  timerEnabled: attr(Boolean),
  fireInterval: attr(Number),
  colorHexValue: attr(String)
});
export default ProtoBaseModel.extend({
  timerSettings: repeated(TimerSetting),
  layouts: repeated(Layout),
  textSize: attr(KDSUISettings.TextSize),
  sounds: repeated(Sound),
  columns: attr(KDSUISettings.Columns),
  ticketLayoutSetting: attr(TicketLayoutSetting),
  prepStartTimeHintsEnabled: attr(Boolean)
});